import isNumber from 'lodash/isNumber';
import { convertToFloat } from './convertToFloat';
import { isNonEmptyString } from './isNonEmptyString';

export const convertToFloatIfStringOrNumber = (value) =>
  isNonEmptyString(value) || isNumber(value)
    ? convertToFloat(value)
    : null;
